import React from 'react';
import { projectionOptions } from '../../utils/projectionCatalog';

export default function ProjectionSelector({
  projectionId,
  onProjectionChange,
  showIndicatrix,
  onToggleIndicatrix,
  showHeatmap,
  onToggleHeatmap,
}) {
  return (
    <section className="gis-panel projection-selector-panel">
      <h2>Projection Selector</h2>
      <label className="gis-label" htmlFor="projection-select">
        Coordinate Reference System
      </label>
      <select
        id="projection-select"
        className="gis-select"
        value={projectionId}
        onChange={(event) => onProjectionChange(event.target.value)}
      >
        {projectionOptions.map((projection) => (
          <option key={projection.id} value={projection.id}>
            {projection.name} ({projection.epsg})
          </option>
        ))}
      </select>

      <div className="toggle-row">
        <label htmlFor="indicatrix-toggle">Tissot&apos;s Indicatrix</label>
        <input
          id="indicatrix-toggle"
          type="checkbox"
          checked={showIndicatrix}
          onChange={(event) => onToggleIndicatrix(event.target.checked)}
        />
      </div>

      <div className="toggle-row">
        <label htmlFor="heatmap-toggle">Distortion Heatmap</label>
        <input
          id="heatmap-toggle"
          type="checkbox"
          checked={showHeatmap}
          onChange={(event) => onToggleHeatmap(event.target.checked)}
        />
      </div>
    </section>
  );
}
